<div class="process-result-container">
  <div class="process-result">
    <h1 class="process-result__header">
      <ng-content select="[ten-process-result-header]"></ng-content>
    </h1>
    <h2 class="process-result__sub-header">
      <ng-content select="[ten-process-result-sub-header]"></ng-content>
    </h2>

    <div *ngIf="!useImageIcon">
      <mat-icon class="material-icons process-result__icon--tick" *ngIf="result === 'success'">check</mat-icon>
      <mat-icon class="material-icons process-result__icon--cross" *ngIf="result === 'failure'">close</mat-icon>
    </div>

    <div *ngIf="useImageIcon">
      <img
        src="/assets/images/validation-icons/tick-inside-a-circle.svg"
        class="process-result__icon--tick image"
        alt="success"
        *ngIf="result === 'success'"
      />
      <img
        src="/assets/images/validation-icons/cross-inside-a-circle.svg"
        class="process-result__icon--cross image"
        alt="failure"
        *ngIf="result === 'failure'"
      />
    </div>

    <p class="process-result__body mat-body-1">
      <ng-content select="[ten-process-result-body]"></ng-content>
    </p>
    <span class="process-result__icon mat-body-1">
      <ng-content select="[ten-process-result-close-icon]"></ng-content>
    </span>
  </div>
</div>
